import { render, staticRenderFns } from "./TestimonialCard.vue?vue&type=template&id=428bb58f&scoped=true"
import script from "./TestimonialCard.vue?vue&type=script&lang=js"
export * from "./TestimonialCard.vue?vue&type=script&lang=js"
import style0 from "./TestimonialCard.vue?vue&type=style&index=0&id=428bb58f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428bb58f",
  null
  
)

export default component.exports